module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/management/business-units/corporate/corporate.component.css
// module id = ./src/app/web/game/management/business-units/corporate/corporate.component.css
// module chunks = main